import * as React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { Breadcrumb, Heading } from 'vet-bones/design-system/components';

import {
  ORGANIZATION_DASHBOARD_BREADCRUMB_ORG,
  ORGANIZATION_DASHBOARD_ENDPOINTS_HEADING,
} from 'src/ui/constants/testIds';
import { OrganizationEndpointTable } from 'src/ui/containers/organization/OrganizationEndpointTable';
import { useOrganization } from 'src/ui/hooks/organization';
import * as copy from 'src/ui/templates/copy';
import { buildDashboardRoute } from 'src/ui/utils/buildRoute';

export const OrganizationEndpoints: React.VFC = () => {
  const history = useHistory();
  const { org } = useParams<{ org: string }>();

  const { organization } = useOrganization(org);

  if (!organization) {
    return null;
  }

  return (
    <div className="organization-dashboard">
      <div className="organization-dashboard-header">
        <div className="organization-dashboard-header-info">
          <Heading
            size="xl"
            testId={ORGANIZATION_DASHBOARD_ENDPOINTS_HEADING}
            weight="semibold"
          >
            {organization.name}
          </Heading>
          <Breadcrumb
            items={[
              {
                id: 'org',
                onClick: () => history.push(buildDashboardRoute(org)),
                testId: ORGANIZATION_DASHBOARD_BREADCRUMB_ORG,
                text: organization.name,
              },
              {
                id: 'endpoints',
                text:
                  copy.components.organization.dashboard.breadcrumb.endpoints,
              },
            ]}
          />
        </div>
      </div>

      <OrganizationEndpointTable />
    </div>
  );
};
